'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEntry = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _keyPaths = require('../constants/keyPaths');

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _applyIdInvariant = require('./applyIdInvariant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Delete an entry in IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to delete the entry in
 * @returns {IndexedAsyncData}
 */
var deleteEntry = exports.deleteEntry = (0, _curry2.default)(function (id, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

  var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);
  return indexedData.updateIn(_keyPaths.ENTRIES, function (entries) {
    return entries.delete(key);
  });
});